import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { ALERTS_FEATURE, AlertsState, StateWithAlerts } from '../alerts-state';

export const getAlertsState: MemoizedSelector<StateWithAlerts, AlertsState> = createFeatureSelector<AlertsState>(ALERTS_FEATURE);
